import { makeCanvasByUrl } from '../util.js';

export function isEmptyInCanvas(imageData) {
  let has_sth = false;
  for (let x = 0; x < imageData.width * imageData.height; ++x) {
    if (imageData.data[x * 4 + 3] !== 0) {
      has_sth = true;
      break;
    }
  }
  return !has_sth;
}
export function isEmptyCanvas(canvas) {
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

  for (let i = 3; i < imageData.length; i += 4) {
    if (imageData[i] !== 0) {
      return false;
    }
  }
  return true;
}
export const isEmptyImg = async (src) => {
  const canvas = await makeCanvasByUrl(src);
  return isEmptyCanvas(canvas);
};
